<template>
  <div class="view_box" :class="isAni ? 'ani':''">
    <div class="title">您的2023年营销总结</div>
    <div>
      <img src="@/assets/images/yearReport/招募.png" alt="">
      <template v-if="Number(data.recruitRate.split('%')[0]) > 15">您今年招募了许多新会员，认识到了很多新朋友呢~</template>
      <template v-else>会员是我们销量确定增长的基础，要记得再多交新朋友哦！</template>
    </div>
    
    <div>
      <img src="@/assets/images/yearReport/转化.png" alt="">
      <template v-if="Number(data.transRate.split('%')[0]) <= 65">今年认识的新朋友对你特别认可！他们都在店铺完成了首单~</template>
      <template v-else>不过你还有许多新朋友没下单呢！试试给他们发个优惠券吧！</template>
    </div>
    
    <div>
      <img src="@/assets/images/yearReport/复购.png" alt="">
      <template v-if="Number(data.rebuyRate.split('%')[0]) > 0.1">你的老朋友们还是对你如此偏爱，可要记得多跟他们互动哟~</template>
      <template v-else>认识了新朋友可不要忘记老友们呐！他们可是有极强的爆发力量！</template>
    </div>

    <template v-if="data.isOpenRemind1111">
      <div><img src="@/assets/images/yearReport/流失.png" alt="">因为你的关心，留下了许多差点走丢的好朋友，明年要继</div>
      <div style="margin-left: 28px; margin-top: -18px;">续保持哦~</div>
    </template>
    <template v-else>
      <div><img src="@/assets/images/yearReport/流失.png" alt="">啊哦，但还是很可惜，走丢了一些好朋友，但没关系，</div>
      <div style="margin-left: 28px; margin-top: -18px;">明年我们一起努力挽回吧！</div>
    </template>
  </div>
</template>

<script>
export default {
  name: "",
  components: {},
  props: {
    isAni:{
      type:Boolean,
      default:true,
    },
    data: {
      type: Object,
      default: ()=> {}
    }
  },
  data() {
    return {};
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
@keyframes view_box_s {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.ani{
  animation: view_box_s 1.5s ease-in;
  animation-fill-mode: both;
  border-radius: 16px;
}
.view_box {
  position: relative;
  width: 100%;
  height: 100%;

  padding: 50px;
  font-size: 14px;
  color: #000000;
  line-height: 16px;
  font-family: PingFang SC;
  background-image: url("../../assets/images/yearReport/P9.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;

  div {
    font-family: PingFang SC;
    width: 100%;
    margin-bottom: 20px;

    img {
      width: 20px;
      height: 20px;
      margin-right: 8px;
    }
  }



  .title {
    font-size: 24px;
    font-weight: bold;
    line-height: 28px;
    margin-bottom: 30px;
  }

  .font_color {
    color: #0b79ff;
    font-weight: bold;
    font-size: 18px;
    line-height: 24px;
  }
}
</style>